import { dataCubeEye } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCubeEye = /*#__PURE__*/createIcon(dataCubeEye)
export default IconCubeEye
